import React from 'react'
import Level2LayoutProps from '../types/Level2LayoutProps'
import { ItemLevel2 } from '../types/Item'

const INITIAL_PAGE = 'https://bpl.bc.ca' + window.location.pathname;

const LANGUAGES = [
  {
    // Chinese - Traditional
    title: '繁體字',
    slug: 'zh-TW',
    menusIcon: require("~images/illo/language/chinese.jpg") as string,
    menusIconHover: require("~images/illo/language/chinese (hover).jpg") as string,
  },
  {
    // Chinese - Simplified
    title: '简体字',
    slug: 'zh-CN',
    menusIcon: require("~images/illo/language/chinese.jpg") as string,
    menusIconHover: require("~images/illo/language/chinese (hover).jpg") as string,
  },
  {
    // Filipino / Tagalog
    title: 'Filipino',
    slug: 'tl',
    menusIcon: require("~images/illo/language/filipino.jpg") as string,
    menusIconHover: require("~images/illo/language/filipino (hover).jpg") as string,
  },
  {
    // Korean
    title: '한국어',
    slug: 'ko',
    menusIcon: require("~images/illo/language/korean.jpg") as string,
    menusIconHover: require("~images/illo/language/korean (hover).jpg") as string,
  },
  {
    // Persian / Farsi
    title: 'فارسی',
    slug: 'fa',
    menusIcon: require("~images/illo/language/farsi.jpg") as string,
    menusIconHover: require("~images/illo/language/farsi (hover).jpg") as string,
  },
  {
    // French
    title: 'Français',
    slug: 'fr',
    menusIcon: require("~images/illo/language/french.jpg") as string,
    menusIconHover: require("~images/illo/language/french (hover).jpg") as string,
  },
]

const LANGUAGES_ITEM : ItemLevel2[] = LANGUAGES.map((language) => {
  return {
    type: 'menuLevel2',
    id: 1,
    url: `https://translate.google.com/translate?hl=en&sl=auto&tl=${language.slug}&u=${INITIAL_PAGE}`,
    title: language.title,
    menusIcon: {
      url: language.menusIcon,
      width:  '200',
      height:  '200',
      title:  '',
    },
    menusIconHover: {
      url: language.menusIconHover,
      width:  '200',
      height:  '200',
      title:  '',
    },
    slug: 'en',
    parent: null,
    lft: 0,
    active: false,
    menusLeftSidebarBlocks: [],
    menusMainColumn: [],
  }
})

export default ({ ...props }: Level2LayoutProps) => {
  return (
    <div className={'level-2'} id={props.level1active.slug}>
      {/*<div className="close-button" onClick={props.handleClose}>Close</div>*/}
      <div className={'switchboard'}>
        <div className="main-column">
          <ul>
            {LANGUAGES_ITEM.map(item => <>
              <li key={item.id} className={item.active ? "active" : ''}>
                <div className="item language">
                  <img className="icon" src={item.menusIcon.url} width={item.menusIcon.width} height={item.menusIcon.height} alt="" />
                  <img className="icon-hover" src={item.menusIconHover.url} width={item.menusIconHover.width} height={item.menusIconHover.height} alt="" />
                  <a href={item.url}>{item.title}</a>
                </div>
              </li>
            </>)}
          </ul>
        </div>
      </div>
    </div>
  )
}